import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Notification} from '../notification.model';
import {endpoints} from '../../../core/configs/endpoints';

@Injectable({providedIn: 'root'})
export class NotificationApiService {
  private readonly _httpClient = inject(HttpClient);

  public getNotifications(): Observable<{ notifications: Notification[] }> {
    return this._httpClient.get<{ notifications: Notification[] }>(
      `${endpoints.user.notification.list}`,
      {responseType: 'json'}
    );
  }

  public getById(id: number): Observable<{ notification: Notification }> {
    return this._httpClient.get<{ notification: Notification }>(
      `${endpoints.user.notification.detail}/${id}`,
      {responseType: 'json'}
    );
  }

  public update(id: number, data: { read?: boolean; hide?: boolean }): Observable<{ notification: { id: number } }> {
    return this._httpClient.post<{ notification: { id: number } }>(
      `${endpoints.user.notification.edit}`,
      {notificationId: id, ...data}
    );
  }

  public getCollectionItemImage(id: number) {
    return this._httpClient.get(`${endpoints.user.notification.image}/${id}`, {
      responseType: 'blob' // Oppure 'arraybuffer' se devi manipolare ulteriormente i dati
    });
  }
}
